import * as ActionTypes from "../ActionTypes.js";
import { toast } from "react-toastify";
import { toggleLost } from "../actions/FlashActions.js";
import { getLostHistory } from "../actions/LostHistoryActions.js";
import { getServerDomain, toastOptions } from "utils";

export const getLost = (dispatch) => {
  return fetch(getServerDomain() + "/lostitems")
    .then(
      (response) => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      (error) => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then((response) => response.json())
    .then((response) =>
      dispatch({ type: ActionTypes.GET_LOST, payload: response })
    )
    .catch((error) => {
      console.log("Get Lost Item ", error.message);
      toast.error("Could not get lost items" + error.message, toastOptions);
    });
};

export const postLost = (dispatch, history, formData) => {
  fetch(getServerDomain() + "/lostitems", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
    body: formData,
    credentials: "include",
  })
    .then(
      (response) => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      (error) => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then((response) => response.json())
    .then((response) => {
      if (response.err) {
        toast.error("Cannot post! " + response.err, toastOptions);
      } else {
        getLost(dispatch);
        toggleLost(dispatch);
        history.push("/lostitems");
        toast.success("Posted successfully!", toastOptions);
      }
    })
    .catch((error) => {
      console.log("POST ", error.message);
      toast.error("Cannot post the item! " + error.message, toastOptions);
    });
};

export const deleteLost = (dispatch, history, lostId) => {
  return fetch(getServerDomain() + "/lostitems/" + lostId, {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  })
    .then(
      (response) => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      (error) => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then((response) => response.json())
    .then(() => {
      history.push("/lostitems");
      toast.success("Item deleted successfully", toastOptions);
      dispatch({ type: ActionTypes.DELETE_LOST, payload: lostId });
    })
    .catch((error) => {
      console.log("Delete Lost Item ", error.message);
      toast.error("Could not delete lost item. " + error.message, toastOptions);
    });
};

export const resolveLost = (dispatch, history, lostItemId, formData) => {
  return fetch(getServerDomain() + "/lostitems/" + lostItemId + "/resolve", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
    body: JSON.stringify(formData),
    credentials: "include",
  })
    .then(
      (response) => {
        if (response.ok) {
          return response;
        } else {
          var error = new Error(
            "Error " + response.status + ": " + response.statusText
          );
          error.response = response;
          throw error;
        }
      },
      (error) => {
        var errmess = new Error(error.message);
        throw errmess;
      }
    )
    .then((response) => response.json())
    .then(() => {
      dispatch({ type: ActionTypes.RESOLVE_LOST, payload: lostItemId });
      history.push("/");
      toast.success("Item resolved successfully,", toastOptions);
      getLostHistory(dispatch);
    })
    .catch((error) => {
      console.log("Resolve Lost Item ", error.message);
      toast.error(
        "Could not resolve lost item. " + error.message,
        toastOptions
      );
    });
};
